var baseUrl = ""
var weChatCallBackUrl = ""


// baseUrl = "https://pre.weiyoubot.cn";
baseUrl = "https://api-xcx.qunsou.co";


var lotto = {
	getShareImg: '/xvote/v3/share',//获取分享图
	wxLogon: '/xvote/web/v1/login',//"登录授权"
	wxSign: '/xvote/web/v1/sign',//wx签名
	getVoteDetail: '/xvote/v1/detail/home',//详情
	getCanvassDetail: '/xvote/v1/option',//拉票详情
	getResultList: '/xvote/v2/users',//结果列表
	getAllList: '/xvote/v4/option_users',//结果详情
	doVote: '/xvote/v3/do',//投票
	getVerifyCode: '/xvote/v1/verify/code',//拿验证码
	getQrCode: '/xvote/web/v1/qrcode',//获取二维码
	checkStatus: '/xvote/web/v1/check_status',//查询扫码状态
	getSchema: '/xvote/v1/schema',//获取小程序链接
}

export default {
	baseUrl,
	lotto,
}



// WEBPACK FOOTER //
// ./src/utils/api.js